// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,

  numero_WhatsApp: "+393512970920",
  numero_telefono: "tel:+3909811848023",

  //text per personalizzare i messaggi
  canShowPagamentoRate: false,
  textShowPagamentoRate: "",

  canShowElencoDate: true,

  /*
  urlWeb: 'http://localhost/',
  urlMaterialeDidattico: 'http://localhost/assets/media/materiale-didattico/1/',
  urlImageCorso: 'http://localhost/assets/media/corso/',
  urlImageCorsoHD: 'http://localhost/assets/media/corso/hd/',
  urlImageVideoCorso: 'http://localhost/assets/media/corso/video/',
  web_api_url_base: 'http://localhost/api/',

  urlStampa: 'http://localhost/stampe/',

  urlAttestati: 'http://localhost/assets/media/certificate/corsisti/',
  urlAttestatiDaCreare: 'http://localhost/pages/certificate/',
  urlImagePartners: 'http://localhost/assets/media/partners/',

  urlJitSiMeet: 'http://localhost/script/external_api.js',
  urlImageMedia: 'http://localhost/assets/media/',

  */

  urlWeb: 'https://discentya.biessesolution.com/',
  urlMaterialeDidattico: 'https://discentya.biessesolution.com/assets/media/materiale-didattico/1/',
  urlImageCorso: 'https://discentya.biessesolution.com/assets/media/corso/',
  urlImageCorsoHD: 'https://discentya.biessesolution.com/assets/media/corso/hd/',
  urlImageVideoCorso: 'https://discentya.biessesolution.com/assets/media/corso/video/',
  web_api_url_base: 'https://discentya.biessesolution.com/api/',

  urlStampa: 'https://discentya.biessesolution.com/stampe/',

  urlAttestati: 'https://discentya.biessesolution.com/assets/media/certificate/corsisti/',
  urlAttestatiDaCreare: 'https://discentya.biessesolution.com/pages/certificate/',
  urlImagePartners: 'https://discentya.biessesolution.com/assets/media/partners/',

  urlJitSiMeet: 'https://discentya.biessesolution.com/script/external_api.js',
  urlImageMedia: 'https://discentya.biessesolution.com/assets/media/',

};

